import axios from "axios";
import authHeader from "./auth-header";
import API_BASE_URL2 from "../config/apiConfig";

const API_BASE_URL = "https://glistening-dedication-production.up.railway.app/api/courses/";

// const API_BASE_URL = "http://localhost:8080/api/courses/";


// const API_URL = "http://localhost:8080/api/auth/";

// const API_BASE_URL = `${API_BASE_URL2}/courses/`;


// Méthode pour uploader une image sur le serveur
const uploadImage = async (image) => {
    if (!image) {
        alert("Veuillez sélectionner une image.");
        throw new Error("Aucune image fournie.");
    }

    const formData = new FormData();
    formData.append("file", image);

    try {
        console.log("Envoi de l'image au backend : ", image);
        const response = await axios.post(API_BASE_URL + "upload-image", formData, {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data",
            },
        });
        console.log("Réponse de l'upload de l'image :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de l'image :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'upload de l'image.";
        throw new Error(errorMessage);
    }
};

// Méthode pour créer un cours avec les données et l'image
const createCourse = async (courseData, file) => {
    // alert(" ...authHeader()" +  ...authHeader())
    if (!courseData || !file) {
        alert("Données ou fichier manquants pour créer le cours.");
        throw new Error("Les données du cours ou le fichier ne sont pas fournis.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("course", JSON.stringify(courseData));

    try {
        console.log("Envoi des données du cours au backend :", courseData);
        const response = await axios.post(API_BASE_URL + "create-course", formData, { headers: authHeader() });
        console.log("Réponse de la création du cours :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création du cours :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de la création du cours.";
        throw new Error(errorMessage);
    }
};

const updateCourse = async (id, courseData, file) => {
    if (!id || !courseData) {
        throw new Error("L'ID du cours ou les données sont manquants.");
    }

    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }

    // Convertir imageUrl en image
    const cleanCourseData = { ...courseData };
    if (cleanCourseData.imageUrl) {
        cleanCourseData.image = cleanCourseData.imageUrl;
        delete cleanCourseData.imageUrl;
    }
    formData.append("course", JSON.stringify(cleanCourseData));

    try {
        const response = await axios.put(
            `${API_BASE_URL}update-course/${id}`,
            formData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du cours :", error.response || error.message);
        throw new Error(error.response?.data || "Erreur lors de la mise à jour du cours.");
    }
};




const getCoursesByModerator = async (moderatorId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}?userId=${moderatorId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des cours :", error);
        throw error;
    }
};

// const update_infos_employe_by_id = (id, data) => {
//     return axios.put(`${API_URL}update/${id}`, data, { headers: authHeader() });
//   };

const addSubjectToCourse = async (courseId, subjectData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/subjects`,
            subjectData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du sujet :", error);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'ajout du sujet.";
        throw new Error(errorMessage);
    }
};
// const getSubjectsByCourse = async (courseId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}${courseId}/subjects`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des sujets :", error);
//         throw error;
//     }
// };


const getSubjectsByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/subjects`, {
            headers: authHeader() // Ajout du token d'authentification
        });

        return response.data.map(subject => ({
            id: subject.id,
            group_name: subject.group_name,
            title: subject.title,
            subTitle: subject.subTitle, // Vérifiez que ce champ est bien inclus
            content: subject.content,
            courseId: subject.courseId
        }));
    } catch (error) {
        console.error("Erreur lors de la récupération des sujets :", error);
        throw error; // Relancer l'erreur pour le debug
    }
};


const getCourseDetails = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
        throw error;
    }
};




const getUserPurchases = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}purchases`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des achats :", error);
        throw error;
    }
};

const getCategories = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des catégories :", error);
        throw error;
    }
};


// Récupérer les sous-catégories d'une catégorie
const getSubcategories = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories/${categoryId}/subcategories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des sous-catégories :", error);
        throw error;
    }
};
const addComment = async (subjectId, content) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/comments/${subjectId}`,
            // `http://localhost:8081/api/comments/${subjectId}`,

            { content },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du commentaire :", error);
        throw error;
    }
};

const updateSubject = (subjectId, updatedData) => {
    return axios.put(`${API_BASE_URL}subjects/${subjectId}`, updatedData, { headers: authHeader() });
};

const deleteSubject = async (subjectId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}subjects/${subjectId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression du sujet :", error);
        throw error;
    }
};



// const API_BASE_URL = "http://localhost:8080/api/quizzes";


// const getQuizzesBySubject = (subjectId) => {
//     return axios.get(`${API_BASE_URL}quizzes/subject/${subjectId}`, { headers: authHeader() });
// };

// const getQuizzesBySubject = async (subjectId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}quizzes/subject/${subjectId}`, {
//             headers: authHeader(),
//         });
//         console.log("Réponse API pour le quiz :", response.data); // <-- Vérifie la réponse de l'API
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des quiz :", error);
//         throw error;
//     }
// };


// const submitQuizAnswers = async (quizId, answers) => {
//     try {
//         const response = await axios.post(
//             `${API_BASE_URL}quizzes/${quizId}/submit`,
//             answers,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la soumission du quiz :", error.response || error.message);
//         const errorMessage = error.response?.data?.message || "Erreur lors de la soumission du quiz.";
//         throw new Error(errorMessage);
//     }
// };




const getQuestionsByQuiz = async (quizId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/${quizId}/questions`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des questions :", error);
        throw error;
    }
};




// const submitQuizAnswers = async (quizId, answers) => {
//     try {
//         const response = await axios.post(
//             `${API_BASE_URL}quizzes/${quizId}/submit`,
//             answers,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la soumission des réponses :", error);
//         throw error;
//     }
// };


const submitQuizAnswers = async (quizId, answers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/submit`,
            answers,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la soumission des réponses :", error);
        throw error;
    }
};


// const getQuizzesBySubject = async (subjectId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}subjects/${subjectId}/quizzes`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des quizzes :", error);
//         throw error;
//     }
// };

// const addQuizToSubject = async (subjectId, quizData) => {
//     try {
//         const response = await axios.post(`${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes`, quizData, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de l'ajout du quiz :", error);
//         throw error;
//     }
// };


const addQuizWithQuestions = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes_old`,
            quizData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz avec questions :", error);
        throw error;
    }
};


const deleteQuiz = async (quizId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/${quizId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression du quiz :", error);
        throw error;
    }
};



const getQuizzesBySubject = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}quizzes/subject/${subjectId}`, { headers: authHeader() });
    return response.data;
};


const addQuizToSubject = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes`,
            {
                ...quizData,
                course: { id: subjectId }, // Vérifie que course.id est bien renseigné
            },
            { headers: authHeader() }
        );

        console.log("Quiz ajouté avec succès :", response.data); // Debug

        return response.data; // Retourner la réponse pour mise à jour de l'UI
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz :", error.response?.data || error.message);
        throw error; // Relancer l'erreur pour affichage correct
    }
};



// const addQuestionToQuiz = async (quizId, questionData) => {
//     const response = await axios.post(`${API_BASE_URL}quizzes/${quizId}/questions`, questionData, { headers: authHeader() });

//     if (!response.data || !response.data.id) {
//         throw new Error("Erreur : ID de la question non retourné !");
//     }

//     return response.data;
// };


const addQuestionToQuiz = async (quizId, questionData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/questions`,
            questionData, // Inclure { text, explanation }
            { headers: authHeader() }
        );

        if (!response.data || !response.data.id) {
            throw new Error("Erreur : ID de la question non retourné !");
        }

        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la question :", error);
        throw error;
    }
};


const addAnswerToQuestion = async (questionId, answerData) => {
    if (!questionId) {
        throw new Error("Erreur : ID de la question manquant !");
    }

    const response = await axios.post(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, answerData, { headers: authHeader() });

    return response.data;
};

const getAnswersByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des réponses :", error);
        throw error;
    }
};

const updateQuestionExplanation = async (questionId, explanation) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-explanation`,
            { explanation }, // Envoyer l'explication dans un objet
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'explication :", error);
        throw error;
    }
};
const getQuestionById = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la question :", error);
        throw error;
    }
};

// const updateQuestion = async (questionId, questionData) => {
//     try {
//         const response = await axios.put(`${API_BASE_URL}quizzes/questions/${questionId}`, questionData, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la mise à jour de la question :", error);
//         throw error;
//     }
// };

const updateQuestion = async (questionId, questionData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/questions/${questionId}`, questionData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la question :", error);
        throw error;
    }
};


const updateAnswer = async (answerId, answerData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/answers/${answerId}`, answerData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la réponse :", error);
        throw error;
    }
};

const deleteQuestion = async (questionId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la question :", error);
        throw error;
    }
};

const deleteAnswer = async (answerId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/answers/${answerId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la réponse :", error);
        throw error;
    }
};

const deleteCourse = async (courseId) => {
    try {
        await axios.delete(`${API_BASE_URL}${courseId}`, { headers: authHeader() });
    } catch (error) {
        console.error("Erreur lors de la suppression du cours :", error);
        throw error;
    }
};

// const updateQuiz = async (quizId, quizData) => {
//     try {
//         const response = await axios.put(
//             `${API_BASE_URL}quizzes/${quizId}`,
//             quizData,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la mise à jour du quiz :", error);
//         throw error;
//     }
// };


const updateQuiz = async (quizId, quizData) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/${quizId}`,
            {
                title: quizData.title,
                isChecked: quizData.isChecked,  // ✅ Ajout du champ
                progressPercentage: quizData.progressPercentage,  // ✅ Ajout du champ
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du quiz :", error);
        throw error;
    }
};


const updateQuizProgress = async (quizId, isChecked, progressPercentage) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/${quizId}/updateProgress`, {
            isChecked,
            progressPercentage,
        }, { headers: authHeader() });

        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du quiz :", error);
        throw error;
    }
};

const updateCorrectAnswers = async (questionId, data) => {
    try {
        console.log("📡 Envoi au backend :", questionId, data); // 🔥 Vérification

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/update-correct-answers/${questionId}`, // 🔥 Correction de l'URL
            data,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data); // 🔥 Vérification
        return response.data;
    } catch (error) {
        console.error("❌ Erreur API :", error.response?.data || error.message);
        throw error;
    }
};

const updateAnswersOrder = async (questionId, orderedAnswerIds) => {
    try {
        console.log("📡 Envoi au backend pour mise à jour de l'ordre :", orderedAnswerIds);

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-order`,
            orderedAnswerIds,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de l'ordre des réponses :", error.response?.data || error.message);
        throw error;
    }
};

// Définition de l'objet de service
const courseService = {
    uploadImage,
    createCourse,
    getCoursesByModerator,
    addSubjectToCourse, getSubjectsByCourse, getCourseDetails, getUserPurchases,
    getCategories, getSubcategories, addComment, updateCourse
    , updateSubject, deleteSubject, getQuizzesBySubject, submitQuizAnswers
    , getQuestionsByQuiz,
    getQuizzesBySubject,
    addQuizToSubject,
    deleteQuiz, addQuizWithQuestions, addQuestionToQuiz, addAnswerToQuestion,
    getAnswersByQuestion, updateQuestionExplanation, getQuestionById
    , updateQuestion, updateAnswer, deleteQuestion, deleteAnswer

    , deleteCourse
    , updateQuiz
    , updateQuizProgress
    , updateCorrectAnswers
    , updateAnswersOrder
};

// Exportation de l'objet
export default courseService;
